import { Routes as RoutesRoutes, Route, useLocation } from "react-router-dom";
import ReactGA from "react-ga4"
import { useIsMobile } from "../../hooks/useIsMobile";
import { useAuth } from "../../context/auth";
import { Details } from "../views/Details";
import { Loading } from "../views/Loading";
import { Layout } from "./Layout";
import { useEffect } from "react";

const trackingId = "G-HJTR7B1FKL";
ReactGA.initialize(trackingId);

export const Routes = () => {
  const { isMobile } = useIsMobile();
  const { mapUrl } = useAuth();
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname
    })
  }, [location.pathname])
  
  if (isMobile !== undefined && mapUrl !== null) {
    return (
      <RoutesRoutes>
        {isMobile &&
          <Route path={`${process.env.REACT_APP_INTERNAL_URL}`} element={<Layout isMobile={true} />}>
            <Route path={`bucket/:geohash`} element />
            <Route path={`bucket/:geohash/details/:id`} element={<Details />} />
            <Route path={`details/:id`} element={<Details />} />
          </Route>
        }
        {!isMobile &&
          <Route path={`${process.env.REACT_APP_INTERNAL_URL}`} element={<Layout isMobile={false} />}>
            <Route path={`bucket/:geohash`} element />
            <Route path={`bucket/:geohash/details/:id`} element={<Details />} />
            <Route path={`details/:id`} element={<Details />} />
          </Route> 
        }
      </RoutesRoutes>
    )
  }
  return (
    <RoutesRoutes>
      <Route path="*" element={<Loading />} />
    </RoutesRoutes>
  )
}
